export const BLOCK_MAP_MUTATION = {
  SET_LESSON_PLANS: (state, lessonPlans) => {
    state.lessonPlans = lessonPlans;
  },
  SET_BLOCK_MAPS: (state, blockMaps) => {
    state.blockMaps = blockMaps;
  },
};
